import React from 'react'
import { useSelector } from 'react-redux'
import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { Box, useBreakpointValue } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { Head, MetaTags, LinkRel } from 'src/components/common'
import { wrapper } from 'src/redux'
import { getNltPagesWithHiddenFiltersData } from 'src/utils/getStaticProps'
import { useBackButton } from 'src/utils/hooks'
import { PAGE_CACHE_CONTROL } from 'server/constants'

const NltOffersContainer = dynamic(() => import('src/containers/NltOffersContainer'))
const PageHeaderContainer = dynamic(() => import('src/containers/PageHeaderContainer'))
const NltContentInfo = dynamic(() => import('src/components/Sections/NltContentInfo'))
const ActionBar = dynamic(() => import('src/components/NltOffers/ActionBar'))
const MobileActionBar = dynamic(() => import('src/components/NltOffers/MobileActionBar'))

interface Props {
  page: any
}

const NltSearchPage: NextPage<Props> = ({ page }) => {
  const { t } = useTranslation()
  const router = useRouter()
  const visibleOnMobile = useBreakpointValue({ base: true, md: false })
  const requestedPage = useSelector((state: Store.RootState) => state.nlt.listingPage)

  useBackButton()

  const crumbs = [
    {
      page: 'Home Page',
      href: '/',
      title: 'Home Page',
    },
    {
      page: 'Offerte Noleggio a Lungo Termine',
      href: '/noleggio-a-lungo-termine',
      title: 'Offerte Noleggio a Lungo Termine',
    },
    {
      page: t('nltSenzaAnticipoPage:header.title'),
      href: router.asPath,
      title: t('nltSenzaAnticipoPage:header.title'),
    },
  ]

  return (
    <>
      <Head title={t('nltSenzaAnticipoPage:header.title')} />
      <MetaTags meta={t('nltSenzaAnticipoPage:meta', { returnObjects: true })} />
      <LinkRel
        rel="canonical"
        href={`https://www.carplanner.com/noleggio-a-lungo-termine/senza-anticipo${page && page > 1 ? `?pagina=${page}` : ''}`}
      />

      <PageHeaderContainer
        title={t('nltSenzaAnticipoPage:header.title')}
        description={t('nltSenzaAnticipoPage:header.description')}
        crumbs={crumbs}
        linkHref="/come-funziona-noleggio-a-lungo-termine"
        linkTitle={t('nltSenzaAnticipoPage:header.howItWorksLink')}
        domain="rent"
      />

      <Box w="100%" display="inline-block" pb="24px">
        <ActionBar />

        <NltOffersContainer bgColor="#fcfbfe" />
      </Box>

      {requestedPage < 2 && <NltContentInfo
        title={t('nltSenzaAnticipoPage:infoSection.title')}
        description={t('nltSenzaAnticipoPage:infoSection.text')}
        asHtml
      />}

      {visibleOnMobile &&
        <MobileActionBar />
      }

    </>
  )
}

export const getServerSideProps = wrapper.getServerSideProps(store => async ({ query, res }) => {
  const props = await getNltPagesWithHiddenFiltersData(store, query, [{ 'anticipo': '0' }])

  res.setHeader("Cache-Control", PAGE_CACHE_CONTROL);

  return { props: { ...props } }
})

export default NltSearchPage
